<template>
  <div>
    <v-container fluid>
      <!-- header เดียวกับหน้าอื่นในระบบ: v-toolbar + SubNavbarBackGround -->
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ title }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex align-center pr-4">
            <slot name="toolbar" />
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <div v-if="subtitle" class="text-body-2 text-medium-emphasis mt-3">{{ subtitle }}</div>

      <slot name="filters" />

      <!-- error state -->
      <v-card v-if="error" class="qa-card mt-4" variant="flat">
        <v-card-text class="text-center py-10">
          <v-icon size="46" color="error">mdi-alert-circle-outline</v-icon>
          <div class="text-subtitle-1 mt-3">{{ $t('qaLoadFailed') }}</div>
          <div class="text-body-2 text-medium-emphasis mt-1">{{ error.message || error }}</div>
          <v-btn color="primary" variant="flat" class="mt-4" prepend-icon="mdi-refresh" @click="$emit('retry')">{{ $t('qaRetry') }}</v-btn>
        </v-card-text>
      </v-card>

      <!-- loading state -->
      <div v-else-if="loading" class="mt-4">
        <v-skeleton-loader type="card, table" />
      </div>

      <!-- empty state -->
      <v-card v-else-if="empty" class="qa-card mt-4" variant="flat">
        <v-card-text class="text-center py-10">
          <v-icon size="46" color="grey-lighten-1">mdi-tray-remove</v-icon>
          <div class="text-subtitle-1 mt-3">{{ emptyText || $t('qaNoData') }}</div>
        </v-card-text>
      </v-card>

      <slot v-else />
    </v-container>
  </div>
</template>

<script>
/**
 * เปลือกร่วมของทุกหน้าใน QA Console
 *
 * รวมสิ่งที่ทุกหน้าต้องมีเหมือนกันไว้ที่เดียว: header ตามธีมของระบบ + state ครบชุด
 * (loading / empty / error) — บังคับโดยปริยายว่าทุกหน้าจะมี 3 state นี้ ไม่มีทางลืม
 *
 * ⚠️ Q10 — แบนเนอร์ "โหมดสาธิต" ถูกถอดออก ไม่ใช่แค่เพราะทุกหน้าเป็นของจริงแล้ว
 *    แต่เพราะมันขึ้น**ทุกหน้าเสมอ**ไม่ว่าข้อมูลจริงหรือจำลอง จนกลายเป็นเสียงรบกวน
 *    ที่คนเลิกอ่านไปตั้งนานแล้ว · ส่วนที่ยังไม่มีแหล่งข้อมูลจริงใช้ `<QaMockChip>`
 *    ติดตรงจุดนั้นแทน — ป้ายที่ชี้ของจริงหนึ่งจุด มีคนอ่าน ป้ายที่คลุมทั้งหน้าไม่มี
 */
// สไตล์ร่วมของโมดูล — โหลดครั้งเดียวที่นี่ ทุกหน้าใช้ class .qa-* ได้เลย
import '@/assets/qa-console.css';

export default {
  name: 'QaPageShell',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    error: { type: [Object, String], default: null },
    empty: { type: Boolean, default: false },
    emptyText: { type: String, default: '' },
  },
  emits: ['retry'],
};
</script>

<style scoped>
.title {
  font-size: 18px;
  font-weight: 500;
}
:deep(.qa-card) {
  border: 1px solid #e1e1e1;
  border-radius: 24px;
  overflow: hidden;
}
</style>
